// extracted by mini-css-extract-plugin
export default {"panel":"CollapsePanel_panel__C-YkA","header":"CollapsePanel_header__gXihW","title":"CollapsePanel_title__Azn+b"};